import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BG_META } from "@/components/status";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = useCallback(() => api.get("/admin/users").then((r) => setUsers(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const update = async (uid, changes) => {
    await api.put(`/admin/users/${uid}`, changes);
    toast.success("User updated");
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-users">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">Users</h1>
        <p className="text-muted-foreground text-sm mt-1">Manage roles, verification and access.</p>
      </div>
      <div className="border border-border rounded-md bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-border">
            <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground">
              <th className="px-4 py-3">Name</th><th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">BG Check</th><th className="px-4 py-3">Stripe</th>
              <th className="px-4 py-3">Verified</th><th className="px-4 py-3">Suspended</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users.map((u) => (
              <tr key={u.id} data-testid={`admin-user-${u.id}`}>
                <td className="px-4 py-3"><div className="font-semibold text-sapphire">{u.name}</div><div className="text-xs text-muted-foreground">{u.email}</div></td>
                <td className="px-4 py-3 capitalize">{u.role}</td>
                <td className="px-4 py-3">
                  {u.role === "cleaner" ? (
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded ${BG_META[u.background_check_status]?.cls}`}>{BG_META[u.background_check_status]?.label}</span>
                  ) : <span className="text-xs text-muted-foreground">—</span>}
                </td>
                <td className="px-4 py-3">{u.stripe_onboarded ? <span className="text-emerald-600 text-xs font-semibold">Connected</span> : <span className="text-muted-foreground text-xs">No</span>}</td>
                <td className="px-4 py-3"><Switch checked={!!u.is_verified} onCheckedChange={(v) => update(u.id, { is_verified: v })} data-testid={`verify-${u.id}`} /></td>
                <td className="px-4 py-3"><Switch checked={!!u.is_suspended} onCheckedChange={(v) => update(u.id, { is_suspended: v })} data-testid={`suspend-${u.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
